import { APIGet, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";

type TGetPayout = {
  id?: string | number;
  month?: string | Date | number;
  year?: string | Date | number;
  limit?: number;
  offset?: number;
};

export async function GetPayout(params: TGetPayout, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/facility/payout"), params, useGlobalLoader, token);
}

export async function GetExportPayouts(params: TGetPayout, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/facility/payout/export"), params, useGlobalLoader, token);
}

export async function GetPrintPayouts(params: TGetPayout, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/facility/payout/print"), params, useGlobalLoader, token);
}

export async function GetPrintSinglePayout(params: TGetPayout, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/facility/payout/print/single"), params, useGlobalLoader, token);
}

type TGetPayoutTransactions = {
  payout_id: string | number;
  month?: string | Date | number;
  year?: string | Date | number;
  limit?: number;
  offset?: number;
};

export async function GetPayoutTransactions(
  params: TGetPayoutTransactions,
  useGlobalLoader: boolean,
  token?: CancelToken,
) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/facility/payout/transaction"), params, useGlobalLoader, token);
}

export async function GetExportPayoutTransactions(
  params: TGetPayoutTransactions,
  useGlobalLoader: boolean,
  token?: CancelToken,
) {
  return await APIGet(
    APIUrl(AdminType.FacilityAdmin, "/facility/payout/transaction/export"),
    params,
    useGlobalLoader,
    token,
  );
}
